var map = {
	"./about-us.svg": 629,
	"./betting-icon.svg": 630,
	"./bonus.svg": 631,
	"./coin.png": 632,
	"./contact-us.svg": 633,
	"./download-app.svg": 634,
	"./edit-btn.svg": 635,
	"./feedback.svg": 636,
	"./global.svg": 637,
	"./info-centre.svg": 638,
	"./mall-icon.svg": 639,
	"./message.svg": 640,
	"./redemption-icon.svg": 641,
	"./referral.svg": 642,
	"./resp-gaming.svg": 643,
	"./security.svg": 644,
	"./transaction-icon.svg": 645,
	"./vip-icon.svg": 646,
	"./wallet-icon.svg": 647
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2356;